export default __webpack_public_path__ + "static/media/IMG-20250105-WA0031.b430d7b2.jpg";